module.exports = __webpack_public_path__ + "img/block1Img07.91587df4.png";